import { formatMinorUnits } from 'helpers/formatters';
import { NO_CURRENCY } from 'helpers/currency';
import type { CurrencyStats } from './utils';

export type CurrencyCardProps = {
  currency: string;
  data: CurrencyStats;
};

export const CurrencyCard = ({ currency, data }: CurrencyCardProps) => {
  const isUnknown = currency === NO_CURRENCY;

  // Guarding the two sentinels by name was not enough: Intl throws RangeError on any
  // code it does not recognise, and currency_code is free text -- 'EU4' has 621 rows
  // and 'SEL' has one. formatMinorUnits falls back to a plain number and names the code
  // instead of taking the page down, so no allow-list is needed here.
  return (
    <div className="border-line bg-panel grid gap-[7px] rounded-card border p-[13px]">
      <span className="micro-label">{isUnknown ? 'No currency' : currency}</span>
      <div className="grid gap-1">
        <CurrencyLine label="Sessions" value={data.sessions.toLocaleString()} />
        <CurrencyLine label="Conversions" value={data.conversions.toLocaleString()} />
        <CurrencyLine label="Revenue" value={formatMinorUnits(data.revenue, isUnknown ? null : currency)} />
      </div>
    </div>
  );
};

type CurrencyLineProps = { label: string; value: string };

const CurrencyLine = ({ label, value }: CurrencyLineProps) => (
  <div className="flex items-baseline justify-between gap-2">
    <span className="supporting">{label}</span>
    <span className="num truncate">{value}</span>
  </div>
);
